import { observer } from "mobx-react-lite";
import { useMemo } from "react";

import { formatVariableName } from "./types";

import { SingleSourceSelector } from "@/components/PowerBlock/Block/SourceSelectors";
import { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";
import { FieldType } from "@/components/PowerBlock/Block/types/fieldTypes";
import { TemplateFormat } from "@/types/prompt-blueprint";

interface InputVariableRowProps {
  variableName: string;
  sources: Record<SourceType, string[]>;
  sourceKeyPrefix: string;
  fieldType?: FieldType;
  isHighlighted?: boolean;
  templateFormat?: TemplateFormat;
  forceSelectorOpen?: boolean;
}

const InputVariableRow = observer(
  ({
    variableName,
    sources,
    sourceKeyPrefix,
    fieldType = FieldType.InputVariable,
    isHighlighted = false,
    templateFormat,
    forceSelectorOpen = false,
  }: InputVariableRowProps) => {
    const sourceKey = `${sourceKeyPrefix}.${variableName}`;

    const displayName = useMemo(
      () => formatVariableName(variableName, templateFormat),
      [variableName, templateFormat],
    );

    return (
      <div
        data-smart-table-tour-source-selector={variableName}
        className={`transition-all duration-300 ${
          isHighlighted ? "-m-2 rounded-md bg-blue-50 p-2 ring-2 ring-blue-200" : ""
        }`}
      >
        <SingleSourceSelector
          fieldType={fieldType}
          key={variableName}
          sources={sources}
          name={displayName}
          sourceKey={sourceKey}
          forceOpen={forceSelectorOpen}
          validation={{
            isValid: true,
            message: "Input variable mapping is optional",
          }}
        />
      </div>
    );
  },
);

export default InputVariableRow;
